import React, { useContext } from 'react';
import { convertToDateMonthYear } from '../../utils/ABHelper';
import { ABContext } from '../../contexts/ABContext';
import Card from 'Components/DesignSystem/Card/Card';
import Typography from 'Components/DesignSystem/Typography/Typography';

const ResultSection2 = () => {
    const abContext = useContext(ABContext);
    const { testData } = abContext

    /*
      Both halves were `<label>` elements with no `htmlFor` — and the second one is the
      VALUE, a labelling element used as data. `<dl>` is the right shape for four
      caption/value pairs: the association is structural, so a screen reader reads
      "Start Date, 7 Aug 2026" rather than four captions followed by four numbers.
    */
    const entry = (label: string, value: string, testId: string) => {
        return (<div className="tw-w-[40%] tw-ms-4">
            {/* `Typography` has no `dt`/`dd` in its element union, and widening a shared
                type for one consumer is the wrong trade — the tokens go on a span inside
                the semantic element instead. */}
            <dt>
                <Typography variant="sub-title-label" as="span" className="tw-text-ink-tertiary tw-block">
                    {label}
                </Typography>
            </dt>
            <dd className="tw-m-0">
                <Typography variant="body-primary" as="span" className="tw-text-ink" data-testid={testId}>
                    {value}
                </Typography>
            </dd>
        </div>)
    }

    return (
        <section>
            <Card elevation="none" className="tw-mt-6 tw-p-2" data-testid="ab-result-meta">
                <dl className="tw-flex tw-items-center tw-justify-evenly tw-m-0">
                    {entry("Start Date", convertToDateMonthYear(testData?.started_at), "ab-result-start-date")}
                    {entry("End Date", convertToDateMonthYear(testData?.ended_at), "ab-result-end-date")}
                    {entry("Run Duration", `${testData?.analyzed_duration}/${Math.ceil(testData?.test_duration)}`, "ab-result-run-duration")}
                    {entry("Created by", testData?.ownership?.username, "ab-result-created-by")}
                </dl>
            </Card>
        </section>
    );
}

export default ResultSection2;